import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Slides from '@ifeng-fe/ui_pc_slides';
import errorBoundary from '@ifeng-fe/errorBoundary';

class TopSlides extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    sliderTmpl = item => {
        return (
            <div className={styles.slideItem}>
                <a href={item.url} className={styles.slidePicLink} target="_blank" data-nomask>
                    <img src={item.src} className={styles.slidePic} />
                </a>
                <div className={styles.slideText} />
                <p className={styles.slideTitle}>
                    <a href={item.url} className={styles.slideTitleLink} target="_blank" data-innermask>
                        {item.title}
                    </a>
                </p>
            </div>
        );
    };

    render() {
        const { content } = this.props;
        const config = {
            dots: true,
            dotsAction: 'hover',
            autoplayInterval: 1500,
            dotStyle: styles.dot,
            dotCurrentStyle: styles.current,
            sliderTmpl: this.sliderTmpl,
        };

        return (
            <div className={styles.slideBox}>
                <Slides content={content} config={config} />
            </div>
        );
    }
}

export default errorBoundary(TopSlides);
